import { Link } from "react-router-dom";

export default function SectionHeading({
  kicker,
  title,
  desc,
  morePath,
  moreLabel = "查看全部",
}: {
  kicker?: string;
  title: string;
  desc?: string;
  morePath?: string;
  moreLabel?: string;
}) {
  return (
    <div className="flex items-end justify-between gap-4 mb-6 md:mb-8">
      <div>
        {kicker && (
          <span className="inline-flex items-center gap-2 text-xs font-label font-semibold text-primary-600 mb-2">
            <span className="w-4 h-px bg-primary-500" />
            {kicker}
          </span>
        )}
        <h2 className="font-heading text-xl md:text-3xl font-bold text-foreground-950">{title}</h2>
        {desc && <p className="mt-2 text-sm text-foreground-500 max-w-2xl">{desc}</p>}
      </div>
      {morePath && (
        <Link
          to={morePath}
          className="hidden sm:inline-flex items-center gap-1 text-sm font-label text-primary-600 hover:text-primary-700 whitespace-nowrap shrink-0"
        >
          {moreLabel}
          <i className="ri-arrow-right-line" />
        </Link>
      )}
    </div>
  );
}